import {types} from './types';

const setGetJackpotHistoryListAction = (payload) => {
    return {
        type: types.SET_HISTORY_LIST,
        payload,
      }
}

export {
  setGetJackpotHistoryListAction
}
